// src/components/ui/input.js
import React from 'react';
import { cn } from '../../lib/utils'; // Path relative to input.js

const Input = ({ type = 'text', value, onChange, placeholder, className = '', startContent, ...props }) => {
  return (
    <div className="relative">
      {startContent && (
        <div className="absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none">
          {startContent}
        </div>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={cn(
          'bg-white/10 backdrop-blur-md rounded-xl border border-white/10 shadow-lg',
          'w-full text-white placeholder:text-gray-400 py-2 pr-3 focus:outline-none',
          'focus:ring-2 focus:ring-green-400 focus:border-green-400',
          'border-green-500/30',
          startContent ? 'pl-8' : 'pl-3', // Adjust padding if startContent exists
          className // Apply any additional class names passed from parent
        )}
        {...props} // Pass any other props down to the input element
      />
    </div>
  );
};

export default Input;
